import { createSlice } from '@reduxjs/toolkit'

const aboutSlice = createSlice({
    name: 'about',
    initialState: {
      about: [
       
      ]
    }
    ,
    reducers: {
        about: (state, action) => {
            state.about = action.payload;
        }
    }
})

export const {about} = aboutSlice.actions;
export default aboutSlice.reducer;
